import reducer from './reducers';

export { default as groupsOperations } from './operations';
export { default as communitiesTypes } from './types';
export { default as groupsSelectors } from './selectors';

export default reducer;
